/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown>, date: NonNullable<unknown> }} Membership_Plan_Change_PendingInputs */

const fr_membership_plan_change_pending = /** @type {(inputs: Membership_Plan_Change_PendingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Passage à ${i?.plan} programmé le ${i?.date}.`)
};

/**

* @param {Membership_Plan_Change_PendingInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_plan_change_pending = /** @type {((inputs: Membership_Plan_Change_PendingInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Plan_Change_PendingInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_plan_change_pending(inputs)
});